// URL Web3Auth should come back to after its redirect login (uxMode: "redirect").
// The library default is protocol + host + pathname only, which drops the query
// string (`r`, `response_type`, `logout`, ...), so the page reloaded after
// Web3Auth could no longer tell where to return. Keep the query as-is; the
// hash (#b64Params=...) is appended by the library, so it is not included.
export function buildWeb3authRedirectUrl(location) {
  if (!location || typeof location.protocol !== 'string' || typeof location.host !== 'string') {
    return undefined;
  }

  let search = typeof location.search === 'string' ? location.search : '';
  if (/[?&]b64Params=/.test(search)) {
    const params = new URLSearchParams(search);
    params.delete('b64Params');
    const rest = params.toString();
    search = rest ? `?${rest}` : '';
  }

  return `${location.protocol}//${location.host}${location.pathname || '/'}${search}`;
}

export function currentWeb3authRedirectUrl() {
  return typeof window === 'undefined' ? undefined : buildWeb3authRedirectUrl(window.location);
}
